module.exports = __webpack_public_path__ + "static/img/guide-topico3.f86b93d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide-topico3.png
// module id = qh4D
// module chunks = 1